import { render } from "./DocumentViewer.vue?vue&type=template&id=4fcd3842&scoped=true&ts=true"
import script from "./DocumentViewer.vue?vue&type=script&lang=ts"
export * from "./DocumentViewer.vue?vue&type=script&lang=ts"

import "./DocumentViewer.vue?vue&type=style&index=0&id=4fcd3842&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fcd3842"]])

export default __exports__